import LibraryApi from '@/api/library/library.js'

const state = {
    index_content: {},
    library_content: {}

}

const mutations = {
    change_library_index (state, category) {
        state.index_content = category
    },
    change_library_content (state, libraryContent) {
        state.library_content = libraryContent
    }
}

const actions = {
    async change_library_index (context) {
        let category = await LibraryApi.get_library_index()
        context.commit('change_library_index', category.data)
    },

    async change_library_content (context, args) {
        let content = await LibraryApi.get_library_content(args)
        context.commit('change_library_content', content.data)
    },
    async get_library_item (context, args) {
        return await LibraryApi.get_library_item(args)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
